export const rules = [
  {
    id: 1,
    title: "Respeto a todos los traders por igual",
    description: "En NSL valoramos el respeto mutuo. Todos los miembros merecen ser tratados con dignidad, independientemente de su nivel de experiencia o resultados en trading.",
    icon: "🤝",
    quiz: {
      question: "¿Puedo burlarme de un trader por sus pérdidas?",
      correctAnswer: false
    }
  },
  {
    id: 2,
    title: "Prohibido tradear otras metodologías",
    description: "Para mantener la coherencia y el enfoque de la comunidad, solo se permite el uso de la metodología SMC/ICT.",
    icon: "📊",
    quiz: {
      question: "¿Puedo compartir setups de Wyckoff o Elliott en el Discord?",
      correctAnswer: false
    }
  },
  {
    id: 3,
    title: "Prohibido ser promotor de trading",
    description: "Si eres tan bueno, qué haces acá? Esta rotundamente prohibido que alguien quien venda cursos, mentorias, livetrading etc pertenezca a NSL.",
    icon: "🚫",
    quiz: {
      question: "¿Puedo promocionar mi canal de señales aquí?",
      correctAnswer: false
    }
  }
];